import styled from '@emotion/styled';

import { useI18n } from '../../../hooks/useI18nFormatters';

import { cssClass } from '../../../theme/cssClass';
import { glyph } from '../../../theme/glyph';
import { motion } from '../../../theme/motion';
import { theme } from '../../../theme/theme';

import { MonoButtonRound } from '../../../components/buttons/MonoButtonRound';
import { SpinnerLoading } from '../../../components/common/SpinnerLoading';

export function SaveButton(props) {
  const { i18n } = useI18n();

  return (
    <MonoButtonRound
      styleColor="blue"
      isDisabled={props.hasUnsavedChanges === false || props.isSaving}
      onPress={props.onPress}
    >
      <SaveButton.AnimationContainer data-is-saving={props.isSaving}>
        <SaveButton.IconWrapper>
          <MonoButtonRound.Icon source={glyph.core.checkmark} size={theme.icon.size_default} />
        </SaveButton.IconWrapper>
        <SaveButton.SpinnerWrapper>
          <SpinnerLoading color={theme.icon.color_light} size="16px" />
        </SaveButton.SpinnerWrapper>
      </SaveButton.AnimationContainer>
      <MonoButtonRound.Text className={cssClass.showForLarge}>
        {i18n.messageFormatter('common.save')}
      </MonoButtonRound.Text>
    </MonoButtonRound>
  );
}

SaveButton.SpinnerWrapper = styled.div`
  position: absolute;
  top: 0;
  inset-inline-start: 0;
  opacity: 0;
  transition: ${motion.duration.fast} ${motion.curve.fast_in};
  transition-property: opacity;
`;

SaveButton.IconWrapper = styled.div`
  opacity: 1;
  transition: ${motion.duration.fast} ${motion.curve.fast_in};
  transition-property: opacity;
`;

SaveButton.AnimationContainer = styled.div`
  position: relative;
  width: ${theme.icon.size_default};
  height: ${theme.icon.size_default};

  &[data-is-saving='true'] {
    ${SaveButton.SpinnerWrapper} {
      opacity: 1;
    }

    ${SaveButton.IconWrapper} {
      opacity: 0;
    }
  }
`;
